const React = require("react");
const PropTypes = require("prop-types");
const {Providers, Decorators: {Injector}} = require("core");

@Injector(["store"])
class List extends React.Component {

    static get propTypes() {
        return {
            collection: PropTypes.any,
            label: PropTypes.string,
            menu_id: PropTypes.string,
            menu_row_id: PropTypes.string,
        };
    }

    static get defaultProps() {
        return {
            collection: [],
            label: null,
        };
    }

    get collection() {
        if(this.props.collection && this.props.collection.length > 0){
            return this.props.collection;
        }
        if(this.props.store && this.props.store.collection){
            return this.props.store.collection;
        }
        return this.props.collection;
    }

    get has_data() {
        return this.collection.length > 0;
    }

    get templates() {
        return React.Children.toArray(this.props.children);
    }

    getRowId(data) {
        if (typeof(data[this.props.menu_row_id]) === 'undefined') {
            return '';
        }

        return data[this.props.menu_row_id];
    }

    labelClicked = () => {
        this.collection.toggleHide();
    };

    isActive(datum){
        if(this.props.store && this.props.store.active){
            if(datum.id > 0 && datum.id === this.props.store.active.id){
                return true;
            }
        }
        return false;
    }

    renderItem(datum, i) {

        let key = i;
        if(typeof this.props.keyed === 'function'){
            key = this.props.keyed(datum);
        }

        return (
            <React.Fragment key={key} >
                <Providers.Data data={datum} >
                    {this.templates.map(template => {
                        return React.cloneElement(template, {data_index: i, data: datum, entries: this.collection, isActive: this.isActive(datum)});
                    })}
                </Providers.Data>
            </React.Fragment >
        );
    }

    renderItems() {
        if (this.has_data) {
            return this.collection.map((datum, i) => this.renderItem(datum, i));
        }
    }

    renderLabel() {
        if (this.props.label !== null) {
            return (
                <div className="list-label" onClick={this.labelClicked} >
                    <span >{this.props.label} ({this.collection.size})</span >
                </div >
            );
        }
    }

    render() {
        return (
            <React.Fragment >
                {this.renderLabel()}
                {this.renderItems()}
            </React.Fragment >
        )
    }

}

module.exports = List;